import React, { useEffect, useState } from 'react';
import {
  Button,
  Checkbox,
  TextField,
  Menu,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  FormGroup,
  FormControlLabel,
  Box,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import filterImg from '../../../common/images/filter.png';

import './Financial.scss'; // Import the SCSS file for styling

function FilterButton({ sectionsData, handlePageFilter,currentTab}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedItems, setSelectedItems] = useState({});
  const [searchTerm, setSearchTerm] = useState('');
  const [initialLoad, setInitialLoad] = useState(true);
  const [tabsState, setTabsState] = useState({});


  // Function to open dropdown menu
  const handleClickOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };
  // Function to close dropdown menu
  const handleClose = () => {
    setAnchorEl(null);
  };

  // Function to handle search input change
  const handleSearch = (event) => {
    setSearchTerm(event.target.value.toLowerCase());
  };

  const handleApplyFilters = () => {
    handlePageFilter(selectedItems);
    handleClose();
  };

  // Function to clear all selections
  const handleClearAll = () => {
    handlePageFilter();
    setSelectedItems({});
    setSearchTerm(''); // Reset the search term
    handleClose();
  };
  // Function to handle checkbox toggle for individual items
  const handleToggleItem = (section, item) => {
    setSelectedItems((prev) => ({
      ...prev,
      [section]: {
        ...prev[section],
        [item.key]: !(prev[section]?.[item.key]),
      },
    }));
  };

  const handleToggleSelectAll = (section) => {
    const items = sectionsData.find((sec) => sec.title === section).items;
    const areAllSelected = items?.every((item) => selectedItems[section]?.[item.key]);
    
    const newSelectedItems = areAllSelected
      ? {} // If all are selected, set to an empty object to deselect all
      : items.reduce((acc, item) => ({ ...acc, [item.key]: true }), {}); // Else, select all
  
    setSelectedItems((prev) => ({
      ...prev,
      [section]: {
        ...prev[section],
        ...newSelectedItems,
      },

      // ...prev,
      // [section]: newSelectedItems,
    }));
  };
  // Function to automatically select the first two filters in the KPI section
  const selectInitialFilters = () => {
    const initialSelectedItems = {};
    sectionsData?.forEach((section, index) => {
      if (index < 2) { // Only select the first two sections
        initialSelectedItems[section.title] = {};
        section.items?.slice(0, 2)?.forEach((item) => { // Select the first two items in each section
          initialSelectedItems[section.title][item.key] = true;
        });
      }
    });
    return initialSelectedItems;
  };

  // Update filters when the tab changes
  useEffect(() => {
    // Check if the tab has been visited before and has a state
    if (tabsState[currentTab]) {
      // If it has a state, use it
      setSelectedItems(tabsState[currentTab]);
      handlePageFilter(tabsState[currentTab]);
    } else {
      // If it's the first visit to the tab, initialize with the first two filters
      const initialFilters = selectInitialFilters();
      setTabsState(prevTabsState => ({
        ...prevTabsState,
        [currentTab]: initialFilters
      }));
      setSelectedItems(initialFilters);
      handlePageFilter(initialFilters);
    }
  }, [currentTab]); // Dependency on currentTab to reset when the tab changes

  // Save the current state when filters are manually changed
  useEffect(() => {
    setTabsState(prevTabsState => ({
      ...prevTabsState,
      [currentTab]: selectedItems
    }));
  }, [selectedItems]);



  
  // Filter items by search term
  const getFilteredItems = (items) => {
    return items?.filter((item) => item?.label?.toLowerCase().includes(searchTerm));
  };

  return (
    <div>
     <div className='filter-dropdown'>

<button onClick={handleClickOpen} className='v-align filters-button' type='button'>
  <img src={filterImg} alt='filter' />
  Filters
</button>

</div>
      
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        keepMounted
        PaperProps={{ style: { maxHeight: '50vh', width: '100vh', maxWidth: '20%' } }}
      >
        <div className="kpi-search-select">
          <div>Please select the KPI's from the list(actual text to appear)</div>
          <TextField
            autoFocus
            margin="dense"
            label="Search"
            type="search"
            fullWidth
            variant="standard"
            onChange={handleSearch}
          />
          {sectionsData?.map((section) => (
            <Accordion key={section.title} defaultExpanded TransitionProps={{ unmountOnExit: true }}>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography>{section.title}</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={getFilteredItems(section.items)?.every(
                          (item) => !!selectedItems[section.title]?.[item.key]
                        )}
                        onChange={() => handleToggleSelectAll(section.title)}
                      />
                    }
                    label="Select All"
                  />
                  {getFilteredItems(section.items)?.map((item) => (
                    <FormControlLabel
                      key={item.key}
                      control={
                        <Checkbox
                          checked={!!selectedItems[section.title]?.[item.key]}
                          onChange={() => handleToggleItem(section.title, item)}
                        />
                      }
                      label={item.label}
                    />
                  ))}
                </FormGroup>
              </AccordionDetails>
            </Accordion>
          ))}
          <Box display="flex" justifyContent="space-between" padding={2}>
            <Button className='filter-button' variant="contained" color="primary" onClick={handleApplyFilters}>
              Apply
            </Button>
            <Button className='filter-button' variant="outlined" color="secondary" onClick={handleClearAll}>
              Clear
            </Button>
          </Box>
        </div>
      </Menu>
    </div>
  );
}

export default FilterButton;